export const language: any = {
  title: "Hey! Cooker コミュニティ",
  follow: "フォロー",
  follower: "フォロワー",
  post_share: "共有投稿",
  like_share: "いいね",
  report: "違反を報告",
  delete_post: "投稿を削除",
  delete_comment: "コメントを削除",
  confirm_report: "この投稿がコミュニティガイドラインに違反する内容を含んでいることを確認しますか？報告が成功すると、この投稿は表示されなくなります。",
  confirm_report_comment: "このコメントがコミュニティガイドラインに違反していることを確認しますか？",
  toats_report: "違反を報告していただきありがとうございます。報告内容を確認中です。",
  confirm_delete: "この投稿を削除しますか？",
  confirm_delete_comment: "このコメントを削除してもよろしいですか？",
  toast_delete: "削除に成功しました！",
  text_yes: "はい",
  text_no: "いいえ",
  create: {
    title: "投稿を作成 - Hey!Cooker コミュニティ",
    content_placeholder: "投稿内容を入力してください",
    submit: "今すぐ共有",
    add_image_by_camera: "カメラで撮影",
    add_image_by_gallery: "画像を選択",
    add_video_by_camera: "ビデオを撮影",
    add_video_by_gallery: "ビデオを選択",
  },
  detail: {
    shared: "共有済み",
    shared_community: "コミュニティに写真（動画）を共有しました"
  },
  follwed: "フォロー済み",
  comment: {
    placeholder: "コメントを入力してください",
    submit: "送信",
    nodata: "ここにコメントを残して、最初のコメント投稿者になりましょう！",
    load_more: "さらにコメントを見る",
    not_login: "コメントするにはログインしてください",
    delete: "コメントを削除",
    delete_confirm: "本当にこのコメントを削除しますか？",
    delete_success: "コメントが正常に削除されました",
    report: "違反を報告",
    report_confirm: "このコメントがコミュニティガイドラインに違反していると確信していますか？",
    report_success: "ご報告ありがとうございます。\n現在、審査中です。",
  },
  bottom_navigation: "コミュニティ",
  shared_post: "投稿を共有しました"
}
